export const TOS_URL =
  "https://www.termsfeed.com/live/c5a621f5-7d0a-47ac-bada-fe17f72e45f6";
export const PP_URL =
  "https://www.termsfeed.com/live/4e819f92-d4fb-4f14-8e16-0e554f2878ba";

export const MAPBOX_STYLE =
  "mapbox://styles/sfarley2/clqcjax0l007p01qr6w0s2qmq";

export const ANIMATION_DEFAULTS = {
  resolutionFactor: 0.025, // Multiplied by run duration (in minutes) to get resolution
  secsPerFrame: 0.25,
};

// Environment-based configuration
export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
export const API_URL = process.env.REACT_APP_API_URL;
// KAN-632: the static REACT_APP_API_TOKEN was removed; authenticated API calls
// use the Firebase ID token. Share pages still use HASH_API_TOKEN; replacing
// that static token with signed, expiring share tokens is tracked under KAN-639.
export const HASH_API_TOKEN = process.env.REACT_APP_HASH_API_TOKEN;
export const XYLOPLAN_MAP_API_URL = process.env.REACT_APP_XYLOPLAN_MAP_API_URL;
export const XYLOPLAN_MAP_API_URL_SIGNATURE =
  process.env.REACT_APP_XYLOPLAN_MAP_API_URL_SIGNATURE;
export const FIREBASE_CONFIG = process.env.REACT_APP_FIREBASE_CONFIG
  ? JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG)
  : null;
export const IS_PROD = process.env.NODE_ENV === "production";

// Validate required environment variables
if (process.env.NODE_ENV !== "test") {
  const requiredVars = {
    REACT_APP_MAPBOX_TOKEN: MAPBOX_TOKEN,
    REACT_APP_API_URL: API_URL,
    REACT_APP_FIREBASE_CONFIG: FIREBASE_CONFIG,
  };

  const missingVars = Object.entries(requiredVars)
    .filter(([key, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    console.warn(
      `Missing required environment variables: ${missingVars.join(", ")}\n` +
        "Please check your .env file and ensure all required variables are set."
    );
  }
}
